import { render, staticRenderFns } from "./RidesSearch.vue?vue&type=template&id=71af3e13&scoped=true"
import script from "./RidesSearch.vue?vue&type=script&lang=js"
export * from "./RidesSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af3e13",
  null
  
)

export default component.exports